import SalonCommissionViewController from './SalonCommissionViewController';

export default SalonCommissionViewController;
